<template>
  <a-card :bordered="false" style="position: relative;">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="16">
          <a-col :span="6">
            <a-form-item label="安装类别">
              <a-select  v-model="queryParam.installationType" @change="handleOrder" allowClear="true">
                <a-select-option  v-for="type in restaurantTypes" :title="type.label" :key="type.code">{{type.label}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="订单类型">
              <a-select  v-model="queryParam.orderType" allowClear="true">
                <a-select-option  v-for="type in data1" :title="type.typeName" :key="type.orderTypeId">{{type.typeName}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="成本类型">
              <a-select v-model="queryParam.costType" allowClear="true">
                <a-select-option  v-for="type in restaurantTypes1" :title="type.label" :key="type.code">{{type.label}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="额外费用类型">
              <a-input v-model="queryParam.priceName"></a-input>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8" :offset="16" :style="{ textAlign: 'right' }">
            <span>
              <a-button style="margin-right: 8px;" type="primary" htmlType="submit" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button  @click="clearing">清空</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-divider/>
    <a-row>
      <a-col :span="4" :offset="20" :style="{ textAlign: 'right' }">
        <a-button v-if="editEnabel" type="primary"  icon="plus" @click="$refs.modal.add()">新增</a-button>
        <!--<a-dropdown v-if="removeEnable&&selectedRowKeys.length > 0">-->
        <!--<a-button type="danger" icon="delete" @click="delByIds(selectedRowKeys)">删除</a-button>-->
        <!--</a-dropdown>-->
      </a-col>
    </a-row>
    <s-table
      style="margin-top: 20px"
      size="default"
      ref="table"
      rowKey="modelId"
      :pagination="pagination"
      :loading="loading"
      :columns="columns"
      :data="loadData"
      :scroll="{x:1300}"
      bordered
    >
      <span slot="installationType" slot-scope="text, record">
         <td v-for="type in restaurantTypes" :key="type.code" v-if="record.installationType == type.code">{{type.label}}</td>
      </span>
      <span slot="costType" slot-scope="text, record">
         <td v-for="type in restaurantTypes1" :key="type.code" v-if="record.costType == type.code">{{type.label}}</td>
      </span>
      <span slot="action" slot-scope="text, record" style="white-space: nowrap">
        <a v-if="queryList" @click="handleEdit(record,1)">查看</a>
        <a-divider v-if="queryList" type="vertical"/>
        <span v-if="editEnabel">
          <a @click="handleDeploy(record)">配置</a>
          <a-divider type="vertical" />
          <a @click="handleEdit(record)">编辑</a>
        </span>
        <a-divider v-if="deleteEnable && editEnabel" type="vertical" />
        <a v-if="deleteEnable" @click="delByIds(record.id)">删除</a>
        <span v-if="editEnabel">
          <a-divider type="vertical"/>
          <a v-if="record.disable==1" @click="showState(record.id,record.disable)">启用</a>
          <a v-else @click="showState(record.id,record.disable)">禁用</a>
        </span>
      </span>
    </s-table>
    <model-modal ref="modal" @ok="handleOk"/>
  </a-card>
</template>

<script>
  import { STable } from '@/components'
  import { getPricesList, pricesDisable,delModel,getOrderTypeList } from '@/api/basicdatas/ExtrachargetypeManagement'
  import ModelModal from './modules/ExtrachargeModal.vue'
  import { checkPermission } from '@/utils/permissions'
  import {getDictMap} from "../../utils/dict"
  import {ACCESS_TOKEN} from '@/store/mutation-types'

  export default {
    name: 'ModelList',
    components: {
      STable,
      ModelModal
    },
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        form: this.$form.createForm(this),
        mdl: {},
        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {},
        // 表头
        columns: [
          {
            title: '序号',
            dataIndex: 'num',
            align:'center'
          },
          {
            title: '操作',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },
            width:60
          },
          {
            title: '安装类型',
            dataIndex: 'installationType',
            scopedSlots: { customRender: 'installationType' },
            align:'center'
          },
          {
            title: '订单类型',
            dataIndex: 'orderType',
            align:'center'
          },
          {
            title: '成本类型',
            dataIndex: 'costType',
            scopedSlots: { customRender: 'costType' },
            align:'center'
          },
          {
            title: '额外费用类型',
            dataIndex: 'priceName',
            align:'center'
          },
          {
            title: '添加人',
            dataIndex: 'createBy',
            align:'center'
          },
          {
            title: '添加时间',
            dataIndex: 'createTime',
            align:'center'
          }
        ],
        loadData: parameter => {
          return getPricesList(Object.assign(parameter, this.queryParam))
        },
        fileList: [],
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN)
        },
        uploadUrl: process.env.VUE_APP_API_BASE_URL + '/enterprise/model/importModel',
        pagination: false,
        loading: false,
        restaurantTypes:[],
        restaurantTypes1: [],
        data:[],
        data1:[],
        editEnabel: checkPermission('basicdata:extrachargetypemanagement:edit'),
        deleteEnable: checkPermission('basicdata:extrachargetypemanagement:delete'),
        queryList: checkPermission('basicdata:extrachargetypemanagement:query'),
      }
    },
    filters: {
    },
    async created () {
      this.restaurantTypes = [];
      this.restaurantOperTypeMap = await getDictMap('install_type');
      this.restaurantOperTypeMap.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes.push({code: key, label: value})
      })
      this.restaurantTypes1 = [];
      this.restaurantOperTypeMap1 = await getDictMap('cost_type');
      this.restaurantOperTypeMap1.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes1.push({code: key, label: value})
      })
    },
    methods: {
      handleAdd () {
        this.$refs.modal.add()
      },
      handleEdit (record,status) {
        this.$refs.modal.edit(record,status)
      },
      handleDeploy(record){
        this.$refs.modal.deploy(record)
      },
      handleOk (value) {
        if(value == 1){
          this.$refs.table.refresh(true)
        }else{
          this.$refs.table.refresh()
        }
      },
      clearing(){
        this.queryParam={}
        this.data1=[]
      },
      handleOrder(value){
        // console.log(value)
        getOrderTypeList(value).then(res => {
          console.log(res)
          this.data1 = res.rows
        })
      },
      showState (id,disable) {
        if (disable == 0) {
          pricesDisable({ 'id': id,'disable':1 }).then(res => {
            // console.log(res)
            if (res.code === 0) {
              this.$message.success('禁用成功')
              this.handleOk()
            } else {
              this.$message.error(res.msg)
            }
          })
        } else if (disable == 1) {
          pricesDisable({ 'id': id,'disable':0 }).then(res => {
            // console.log(res)
            if (res.code === 0) {
              this.$message.success('启动成功')
              this.handleOk()
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      },
      handleChange(info) {
        // console.log(info)
        if (info.file.status !== 'uploading') {
          // console.log(info.file, info.fileList);
        }
        if (info.file.status === 'done') {
          this.$message.success('上传成功')

        } else if (info.file.status === 'error') {
          this.$message.error(`${info.file.name} 上传失败.`);
        }
      },
      delByIds (id) {
        let that = this
        this.$confirm({
          title: '删除',
          content: '您确定删除本数据吗？',
          okType: 'danger',
          onOk() {
            delModel({ 'id': id }).then(res => {
              if (res.code === 0) {
                that.$message.success('删除成功')
                that.handleOk()
              } else {
                that.$message.error(res.msg)
              }
            })
          },
          onCancel() {
            console.log('Cancel');
          },
        });
      },
        // fetch () {
        //   this.loading = true
        //   getModelList(Object.assign(this.queryParam)).then(res => {
        //     this.data = treeData(res.rows, 'modelId','brandId')
        //     this.loading = false
        //     console.log(this.data)
        //   })
        // }
    },
    watch: {
      /*
        'selectedRows': function (selectedRows) {
          this.needTotalList = this.needTotalList.map(item => {
            return {
              ...item,
              total: selectedRows.reduce( (sum, val) => {
                return sum + val[item.dataIndex]
              }, 0)
            }
          })
        }
        */
    }
  }
</script>
<style scoped>
  /*.trebtn{
    width: 140px;
    color: white;
    background-color: #17A4E1;
    position: absolute;
    font-size: 15px;
    top: -90px;
    right: 100px;
  }*/
  .trebtn{
    width: 140px;
    color: white;
    background-color: #17A4E1;
    font-size: 15px;
    top: -90px;
    right: 100px;
  }

  .treo{
    right: 548px;
  }
  .treth{
    right: 248px;
  }
  .tret{
    right: 380px;
  }
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td { white-space: nowrap;padding: 4px 16px;}
</style>
